import { useSelector } from "react-redux";
import { deriveReportRevenuePlatformsThatDoNotRemitLabel, deriveReportRevenuePlatformsThatRemitLabel, selectConfigExpressSettingsName, selectConfigExpressTaxCollectionAgreementWith, selectConfigExpressTaxVerbiage } from "../../store/slices/config/configSelectors";
import React, { useMemo } from "react";
import { Text } from "rsuite";

const CollectionAgreementNotice = () => {
  const hasCollectionAgreementWith = useSelector(selectConfigExpressTaxCollectionAgreementWith);
  const taxVerbiage = useSelector(selectConfigExpressTaxVerbiage);
  const county = useSelector(selectConfigExpressSettingsName);
  const platformsThatRemitLabel = useSelector(deriveReportRevenuePlatformsThatRemitLabel);
  const platformsThatDoNotRemitLabel = useSelector(deriveReportRevenuePlatformsThatDoNotRemitLabel);

  const platformsThatHaveCollectionAgreementString = useMemo(() => {
    const labels = hasCollectionAgreementWith?.map(item => item.label);
    return labels.length > 1
      ? labels.slice(0, -1).join(', ') + ' and ' + labels[labels.length - 1]
      : labels[0];
  }, [hasCollectionAgreementWith]);

  const paragraphOne = useMemo(() => {
    return `${county} has signed a collection agreement with ${platformsThatHaveCollectionAgreementString},
     so that by default, ${platformsThatHaveCollectionAgreementString} will remit ${taxVerbiage} directly for all rentals facilitated through their platform. 
     Some hosts have opted out of this process or are part of the Professional Host program, 
     meaning that they must remit their own ${taxVerbiage} to ${county} directly.`;
  }, [county, platformsThatHaveCollectionAgreementString, taxVerbiage]);

  const paragraphTwo = useMemo(() => {
    return `If you have not opted out, you will need to split your collected revenue by platform. 
    If you aren't sure, follow these directions.
    For all bookings made via the ${platformsThatHaveCollectionAgreementString} platforms, report your revenue in the column called "${platformsThatRemitLabel}". 
    For all bookings made by other platforms, report your revenue in the column called "${platformsThatDoNotRemitLabel}".`;
  }, [platformsThatRemitLabel, platformsThatDoNotRemitLabel, platformsThatHaveCollectionAgreementString]);

  return (
    <div className="ph-8 pv-8 section-highlight">
      <Text className="text-bold">Collection Agreement Notice</Text>
      <Text className="paragraph text-small">{paragraphOne}</Text>
      <Text className="paragraph text-small">{paragraphTwo}</Text>
    </div>
  );
};

export default CollectionAgreementNotice;
